import React from 'react';
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const RecipientOrgsDialog = ({
  open,
  onClose,
  colors,
  recipientDialogProduct,
  recipientDialogReleaseType,
  recipientDialogRows,
}) => {
  const columns = [
    { field: 'organization_id', headerName: 'Org ID', width: 90, minWidth: 80 },
    { field: 'org_name', headerName: 'Org', flex: 1, minWidth: 180 },
    { field: 'current_version', headerName: 'Current', width: 100, minWidth: 90 },
    { field: 'planned_version', headerName: 'Planned', width: 100, minWidth: 90 },
    { field: 'planned_targets', headerName: 'Planned Delivery', flex: 1, minWidth: 170 },
    { field: 'source', headerName: 'Rule Source', width: 140, minWidth: 130 },
    {
      field: 'ready',
      headerName: 'Ready',
      width: 100,
      minWidth: 90,
      renderCell: (p) => (
        <Chip
          size="small"
          label={p.value ? 'Yes' : 'No'}
          sx={{
            bgcolor: p.value ? colors.greenAccent[700] : colors.redAccent[700],
            color: colors.grey[100],
          }}
        />
      ),
    },
    { field: 'warnings', headerName: 'Warnings', flex: 1.5, minWidth: 220 },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Recipient Orgs — {recipientDialogProduct?.product || ''}
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={1.5}>
          <Typography variant="body2" sx={{ color: colors.grey[200] }}>
            Shows which orgs currently receive this product and how this release would be delivered to them.
          </Typography>

          <Box display="flex" gap={1} flexWrap="wrap">
            <Chip size="small" label={`Release: ${recipientDialogReleaseType || '-'}`} />
            <Chip size="small" label={`Version: ${recipientDialogProduct?.version || '-'}`} />
            <Chip size="small" label={`Recipient orgs: ${recipientDialogRows.length}`} />
          </Box>

          <Box mt={1} height="50vh" sx={{ width: '100%' }}>
            <DataGrid
              rows={recipientDialogRows}
              columns={columns}
              density="compact"
              disableSelectionOnClick
              hideFooterSelectedRowCount
              pageSize={25}
              rowsPerPageOptions={[25, 50, 100]}
            />
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecipientOrgsDialog;